import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Post, DefaultService as RestApiService } from '../../../swagger-api';

@Injectable({ providedIn: 'root' })
export class PostDetailService {
  private postChanges$: Subject<Post> = new Subject();

  private apiService = inject(RestApiService);

  public get postChanges(): Observable<Post> {
    return this.postChanges$.asObservable();
  }

  public getPostDetailInfo(postId: string): void {
    this.apiService.restSocialPostsGet(postId).subscribe({
      next: (post: Post) => {
        this.postChanges$.next(post);
      },
      error: (error) => {
        this.postChanges$.error(error);
      },
    });
  }
}
